import { RoleResources } from '..'

import stock from './stock'

export const advertiser: RoleResources = {
  advertiser_stock: stock,
}
